import React, {useState, useEffect} from "react"
import styled from "styled-components"
import BtnCompo from "../../SubComponents/Btn"
import FamilyNum from "./Family/FamilyNum"
const Styled = {
        LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    SituationBtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
    `,
}
interface PropsType {
    Points : number;
    setPoints : any;
    Solo_Duo: number;
    setSolo_Duo: any;
}
const Solo=(props:PropsType)=>{
    const [Page, setPage] = useState<boolean>(false)
    const setPoints = props.setPoints
    const Points = props.Points
    const Solo_Duo = props.Solo_Duo
    const setSolo_Duo = props.setSolo_Duo
    if(Page === false){
        return(
            <Styled.Wrap>
              <Styled.LittleTitleFont>
                  가장 어린 아이의 나이는 어떻게 되나요?
                  <br/>(만나이 기준입니다)
              </Styled.LittleTitleFont>
              <Styled.SituationBtnWrap>
                <BtnCompo 
                    content="2세 미만"
                    Point={3}
                    Points={Points}
                    setPoints={setPoints}
                    PageNumber={true}
                    setPage={setPage}
                    Page={Page}
                /> 
                <BtnCompo 
                    content="4세 미만"
                    Point={2}
                    Points={Points}
                    setPoints={setPoints}
                    PageNumber={true}
                    setPage={setPage}
                    Page={Page}
                /> 
                <BtnCompo 
                    content="6세 미만"
                    Point={1}
                    Points={Points}
                    setPoints={setPoints}
                    PageNumber={true}
                    setPage={setPage}
                    Page={Page}
                />  
                <BtnCompo 
                    content="6세 이상"
                    Point={0}
                    Points={Points}
                    setPoints={setPoints}
                    PageNumber={true}
                    setPage={setPage}
                    Page={Page}
                />  
              </Styled.SituationBtnWrap>
            </Styled.Wrap>
          )
    }else{
        return(
            <FamilyNum 
                setPoints={setPoints}
                Points={Points}
                Solo_Duo={Solo_Duo}
                setSolo_Duo={setSolo_Duo}
            />
        )
    }
    
}

export default Solo